// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-components-Feedback-Feedback__link--2iH7A{position:fixed;right:-24rem;background:#000;display:block;padding:7.5rem 15rem;color:#fff;text-decoration:none;font-size:10rem;transform:rotate(-90deg);bottom:215rem}.src-components-Feedback-Feedback__link--2iH7A:hover{background:grey}.src-components-Feedback-Feedback__game--SmeNU{position:absolute;bottom:215rem}", ""]);
// Exports
exports.locals = {
	"link": "src-components-Feedback-Feedback__link--2iH7A",
	"game": "src-components-Feedback-Feedback__game--SmeNU"
};
module.exports = exports;
